import Lenis from "lenis";

let instance: Lenis | null = null;
let rafId = 0;

export function initLenis(): () => void {
  if (instance) return () => {};

  // Skip Lenis on touch devices. Lenis drives its own RAF-based smooth-
  // scroll model; iOS and Android already do momentum scroll natively
  // and the two systems beat against each other, producing the "rubber-
  // band" stalls visible on mobile. Native scroll on touch is already
  // smooth — Lenis adds nothing but latency there. The standard query
  // for a mouse-driven device is hover:hover + pointer:fine.
  if (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    !window.matchMedia("(hover: hover) and (pointer: fine)").matches
  ) {
    return () => {};
  }

  instance = new Lenis();

  const raf = (time: number) => {
    instance?.raf(time);
    rafId = requestAnimationFrame(raf);
  };
  rafId = requestAnimationFrame(raf);

  return () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = 0;
    instance?.destroy();
    instance = null;
  };
}

export function getLenis(): Lenis | null {
  return instance;
}
